import React from 'react'
import { connectCurrentRefinements } from 'react-instantsearch-dom'
import { Button } from '@deseretbook/react-ui'
import PropTypes from 'prop-types'

/**
 * Single button that removes the current applied filters
 *
 * @see https://www.algolia.com/doc/api-reference/widgets/clear-refinements/react/
 *
 * @param {array} items - List of currently applied filters
 * @param {function} refine - Removes the current applied filters
 *
 * @returns {function} React Component
 */
const ClearFiltersComponent = ({ items, refine }) => {
  return (
    <Button onClick={() => refine(items)} disabled={!items.length}>
      Clear Filters
    </Button>
  )
}

ClearFiltersComponent.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  refine: PropTypes.func,
}

export const ClearFilters = connectCurrentRefinements(ClearFiltersComponent)
